/*
 * @Author: cmchiu
 * @Date: 2023-04-06 14:50:57
 * @LastEditTime: 2023-04-06 15:04:55
 * @LastEditors: cmchiu
 * @Description:
 * @FilePath: \IACMP\IACMP_Client\src\store\getters.js
 *
 */
const getters = {
    menusRoutes: state => state.permission.routes,
}
export default getters
